import { RenewalAlert } from '@policyvision/contracts';

import { Client } from '@/common/services/Client';

interface ChangeRenewalAlertsRequest {
  alerts: RenewalAlert[];
}

export async function changeRenewalAlerts(
  renewalUuid: string,
  alerts: RenewalAlert[],
): Promise<void> {
  const response = await Client.put<void, ChangeRenewalAlertsRequest>({
    body: {
      alerts: alerts,
    },
    endpoint: `/renewals/${renewalUuid}/alerts`,
  });
  return response.data;
}
